export default __webpack_public_path__ + "acid-pro.635514ab.png";